export const get_auth_status = (state) => {
  const { auth: { isAuth } } = state;
  return isAuth;
};

export const get_auth_process_states = (state) => {
  const {
    auth:
    {
      states:
      {
        error_message: auth_error_message,
        failure: auth_process_failure,
        loading: auth_process_loading,
        success: auth_process_success
      }
    }
  } = state;
  return {
    auth_error_message,
    auth_process_failure,
    auth_process_loading,
    auth_process_success
  };
};

export const get_auth_user_data = (state) => {
  const { auth: { current_user: { user } } } = state;
  return user;
};
export const get_auth_user_tokens = (state) => {
  const { auth: { current_user: { data } } } = state;
  return data;
};

export const get_enabled_client_list = (state) => {
  const { auth: { current_user } } = state;
  if (current_user.user?.client_id_enabled) {
    return current_user.user.client_id_enabled;
  }
  else return [];
};

export const get_selected_plant_name = (state) => {
  const { auth: { current_user: { user } } } = state;
  if (user) {
    const { selected_plant } = user;
    return { selected_plant };
  }
  return { selected_plant: null };
};

export const get_current_user = (state) => {
  const { auth: { current_user } } = state;
  return current_user.user;
};

export const get_roles_list = (state) => {
  const current_user = get_current_user(state);
  return current_user?.roles_list || [current_user?.role];
};

export const get_current_role = (state) => {
  const current_user = get_current_user(state);
  return current_user?.role || "guest";
};